import DashboardLayout from "@/pages/layouts/DashboardLayout";

let contentRoutes = {
  path: '/content-pages',
  component: DashboardLayout,
  redirect: '/content-pages/create',
  children: [
    {
      path: 'create',
      name: 'Add Content Page',
      component: () => import(/* webpackChunkName: "content-pages" */  '@/pages/pages/ContentForm'),
      meta: {
        permissionsCodes: ['content-pages/create'],
      }
    },
    {
      path: 'edit/:id',
      name: 'Edit Content Page',
      component: () => import(/* webpackChunkName: "content-pages" */  '@/pages/pages/ContentForm'),
      meta: {
        permissionsCodes: ['content-pages/update'],
      }
    }
  ]
}

export default contentRoutes;
